import { render, staticRenderFns } from "./LossesByProduct.vue?vue&type=template&id=b8f93264"
import script from "./LossesByProduct.vue?vue&type=script&lang=js"
export * from "./LossesByProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports